import { render } from "./HeroiconsSolidStatusOnline.vue?vue&type=template&id=0a074323"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidStatusOnline.vue"]])

export default __exports__